<!-- <app-landing-header></app-landing-header> -->
<div class="main">
  <div class="d-flex align-items-center h-100">
    <div class="container-fluid">
      <div class="row justify-content-center">

        <div class="col-12 col-sm-8 col-md-5 col-lg-3 app-forget-password-form
          mx-auto">

          <div class="bg-white p-4 shadow rounded-2x">

            <h1 class="font-weight-bold text-dark mt-3"> Trouble Logging In?</h1>
            <div class="text-center mb-4">Enter your username or email and we'll
              send you a link to get back into your
              account.</div>

            <form (ngSubmit)="onSubmit()" [formGroup]="forgetPassword">
              <div class="form-group w-100">
                <div *ngIf="message" class="alert-" [ngClass]="serverError ?
                  'text-danger' : 'text-success'">
                  {{ message }}
                </div>
                <div *ngIf="email.invalid && email.value">
                  <div *ngIf="email.errors.required">
                    Email is required.
                  </div>
                  <div *ngIf="email.errors.email">
                    Email must be valid
                  </div>
                </div>
                <input type="email" class="form-control w-100" id="email"
                  required formControlName="emailAddress"
                  aria-describedby="emailHelp" placeholder="Enter your email" />
              </div>

              <button type="submit" class="btn btn-primary btn-block w-100"
                [disabled]="!forgetPassword.valid">
                <span class="spinner-border spinner-border-sm" *ngIf="loading"
                  role="status" aria-hidden="true"></span>

                Send Login Link
              </button>
            </form>
            <p class="signup-link mb-0">
              <a routerLink="/">Back to Login</a>
            </p>

          </div>
          <p class="dtext-left"> &nbsp;&nbsp; &copy; {{ dateService.year }}
            Copyright Akorion Company Ltd</p>
        </div>

      </div>
    </div>
  </div>
</div>
